import React from 'react';
import { PauseIcon, PlayIcon } from 'components/icons';
import { ContentBlock } from 'components/commercetools-ui/organisms/hero-banner/types';

interface NavigationPlayPauseButtonProps {
  isPlaying: boolean;
  onToggle: () => void;
  className?: string;
  contentBlock?: ContentBlock[]; 
}

const NavigationPlayPauseButton: React.FC<NavigationPlayPauseButtonProps> = ({
  isPlaying,
  onToggle,
  className = '',
  contentBlock
}) => {
  return (
    <button
      className={`relative group navigation-play-pause-button ${className}`}
      onClick={onToggle}
      aria-label="Carousel autoplay control"
      type="button"
      data-ffid="btn-play-pause-button"
    >
      {isPlaying ? (
        <PauseIcon data-ffid="img-pause-icon" data-testid="img-pause-icon" className="navigation-play-pause-button__icon" aria-hidden="true" />
      ) : (
        <PlayIcon data-ffid="img-play-icon" data-testid="img-play-icon" className="navigation-play-pause-button__icon" aria-hidden="true" />
      )}

      {/* ✅ Corrected Tooltip with dynamic text */}
      <span
        aria-hidden="true"
        className="
          pointer-events-none
          absolute left-1/2 -translate-x-1/2
          bottom-full mb-2
          z-10
          rounded bg-gray-800 text-white text-xs px-2 py-1
          opacity-0 group-hover:opacity-100 group-focus:opacity-100
          transition-opacity duration-200
          max-w-[200px] whitespace-normal text-center shadow-md
        "
      >
        {isPlaying ? `${contentBlock?.[0]?.pauseAutoplay}` : `${contentBlock?.[0]?.resumeAutoplay}`}
      </span>

      <span
        id="carousel-status"
        aria-live="polite"
        className="sr-only"
      >
        {isPlaying ? 'Autoplay is running' : 'Autoplay is paused'}
      </span>
    </button>
  );
};

export default NavigationPlayPauseButton;
